module.exports = __webpack_public_path__ + "static/media/snowman.3b7fa59c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/snowman.svg
// module id = 159
// module chunks = 0